import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Loader from "components/Loader";
import { useSnackbar } from "components/SnackbarContext/SnackbarContext";

import useStyles from "./styles";

export interface IProps extends DialogProps {
  onCancel: () => void;
  onSubmit: () => Promise<void>;
  children: React.ReactNode;
  title: string;
  submitButtonText?: string;
  cancelButtonText?: string;
  isLoading?: boolean;
  scrollable?: boolean;
  disabledAction?: boolean;
  notification?: string;
}

const ActionPopup = (props: IProps) => {
  const {
    children,
    className,
    open = true,
    isLoading = false,
    scrollable = false,
    disabledAction = false,
    onCancel,
    onSubmit,
    onClose,
    title,
    cancelButtonText = "Cancel",
    submitButtonText = "Submit",
    notification
  } = props;

  const classes = useStyles();
  const { showSuccessSnack } = useSnackbar();

  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = async () => {
    try {
      await onSubmit();
      notification && showSuccessSnack(notification);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={className}
      classes={{
        paper: classes.paper,
        paperScrollPaper: classes.paperScrollPaper
      }}
    >
      {isLoading && <Loader overlay />}
      <DialogTitle
        disableTypography={true}
        classes={{ root: classes.titleRoot }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        classes={{
          root: clsx(classes.contentRoot, { scrollable })
        }}
      >
        {children}
      </DialogContent>
      <DialogActions classes={{ root: classes.actionsRoot }}>
        <Button
          className={clsx(classes.actionButton, classes.backOrCloseButton)}
          onClick={handleCancel}
        >
          {cancelButtonText}
        </Button>
        <Button
          className={clsx(classes.actionButton, classes.submitButton)}
          onClick={handleSubmit}
          disabled={disabledAction}
        >
          {submitButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionPopup;
